var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              disabled: _vm.isLoading,
              "data-vv-scope": "form",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.saveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.titleItem) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:100",
                            expression: "'required|max:100'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-description",
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          name: "description",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError(`description`) },
                          ],
                          error: _vm.fnFirstError(`description`),
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "description",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.description",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.description`)) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|integer|min_value:1",
                            expression: "'required|integer|min_value:1'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-order",
                          readonly: _vm.readonlyFormItem,
                          type: "number",
                          name: "order",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError(`order`) },
                          ],
                          error: _vm.fnFirstError(`order`),
                          helpText: `${_vm.pageID}.help.order`,
                        },
                        model: {
                          value: _vm.form.order,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "order",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.order",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.order`)) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialColorPicker",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          id: "input-color",
                          disabled: _vm.readonlyFormItem,
                          name: "color",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("color") },
                          ],
                          error: _vm.fnFirstError("color"),
                        },
                        model: {
                          value: _vm.form.color,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "color",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.color",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.color`)) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c("label", { staticClass: "d-block city-label" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t" +
                        _vm._s(_vm.$t(`${_vm.pageID}.form.relationship`)) +
                        "\n\t\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-wrap d-sm-inline-flex" },
                    _vm._l(_vm.lists.relationship, function (target, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "form-check city-form-check",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.relationship,
                                expression: "relationship",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "checkbox",
                              id: `checkRelationship-${target.code}`,
                              name: `checkRelationship-${target.code}`,
                              disabled: _vm.readonlyFormItem,
                            },
                            domProps: {
                              value: target,
                              checked: Array.isArray(_vm.relationship)
                                ? _vm._i(_vm.relationship, target) > -1
                                : _vm.relationship,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.relationship,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = target,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.relationship = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.relationship = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.relationship = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label text-nowrap",
                              attrs: {
                                for: `checkRelationship-${target.code}`,
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(target.name) +
                                  "\n\t\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3", attrs: { id: "accordion" } },
              _vm._l(_vm.relationship, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "card accordion" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header px-4 py-2",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": `#collapse-${index}`,
                          "aria-expanded": true,
                          "aria-controls": `collapse-${index}`,
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(item.name) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card-body py-4 collapse show",
                        attrs: {
                          id: `collapse-${index}`,
                          "aria-labelledby": `heading-${index}`,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-wrap d-sm-inline-flex" },
                          _vm._l(
                            _vm.getRelationshipList(item.code),
                            function (target, indexRelationship) {
                              return _c(
                                "div",
                                {
                                  key: indexRelationship,
                                  staticClass: "form-check city-form-check",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form[`${item.code}_id`],
                                        expression: "form[`${item.code}_id`]",
                                      },
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "checkbox",
                                      id: `checkTarget-${item.code}-${target.id}`,
                                      name: `checkTarget-${item.code}-${target.id}`,
                                      disabled: _vm.readonlyFormItem,
                                    },
                                    domProps: {
                                      value: target.id,
                                      checked: Array.isArray(
                                        _vm.form[`${item.code}_id`]
                                      )
                                        ? _vm._i(
                                            _vm.form[`${item.code}_id`],
                                            target.id
                                          ) > -1
                                        : _vm.form[`${item.code}_id`],
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.form[`${item.code}_id`],
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = target.id,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.form,
                                                `${item.code}_id`,
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.form,
                                                `${item.code}_id`,
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.form,
                                            `${item.code}_id`,
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "form-check-label text-nowrap",
                                      attrs: {
                                        for: `checkTarget-${item.code}-${target.id}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(target.name) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: false,
              },
              on: {
                save: function ($event) {
                  return _vm.saveItem(`${_vm.moduleCode}.${_vm.pageID}`)
                },
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }